<script>
import EditableNumber from '@components/editables/editable-number.vue';
import { counterMixin } from '@mixins/counter-mixin';

export default {
  components: {
    EditableNumber,
  },
  props: {
    count: {
      type: Number,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    light: {
      type: Boolean,
      required: false,
      default: false,
    },
    allowEditing: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  mixins: [counterMixin],
  data() {
    return {
      displayCount: this.count ? this.count : 0,
    };
  },
  computed: {
    time() {
      return this.$_getFormattedSeconds(this.displayCount);
    },
  },
  mounted() {},
  methods: {
    updateTime(val) {
      this.$emit('adjust-time', val);
    },
    incrementTime() {
      this.updateTime(this.displayCount + 30);
    },
    decrementTime() {
      if (this.displayCount > 0) {
        this.updateTime(this.displayCount - 30);
      }
    },
  },
};
</script>

<template>
  <div :class="['time-counter', { light: light }]">
    <h6 class="section-title" v-if="title">{{ title }}</h6>
    <div class="time-controls">
      <span
        v-if="allowEditing"
        class="time-icon-wrapper"
        @click="decrementTime"
      >
        <BaseIcon class="icon-minus" name="minus" />
      </span>
      <h1 class="time-num">
        <EditableNumber
          v-if="allowEditing"
          tabindex="0"
          :number="time"
          @update-editable-num="updateTime"
          type="time"
        />
        <span v-if="!allowEditing">{{ time }}</span>
      </h1>
      <span
        v-if="allowEditing"
        class="time-icon-wrapper"
        @click="incrementTime"
      >
        <BaseIcon class="icon-minus" name="plus" />
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.time-counter {
  @extend %exercise-counter;

  .section-title {
    color: $color-text;
  }

  .time-controls {
    @extend %exercise-counter-controls;

    .time-num {
      color: $color-text;
      font-size: 2.4rem;
      font-weight: 600;
      margin: 0 2rem;
      max-width: 6.3rem;
      overflow: hidden;
    }

    .time-icon-wrapper {
      @extend %exercise-counter-icons;

      .icon-minus,
      .icon-plus {
        color: $color-medium-gray;
      }
    }
  }

  &.light {
    .section-title {
      color: $color-gray;
    }

    .time-num {
      color: white;
    }

    .time-icon-wrapper {
      background-color: rgba($color-white-wo-rgb, 0.05);

      .icon-minus,
      .icon-plus {
        color: white;
      }
    }
  }
}
</style>
